<template>
    <div>
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder  text-dark"
               :class="item.is_required ? 'required' : ''"
        >
            <slot v-if="i18n.locale.value == 'ar'">
                {{item.label_ar}}
            </slot>
            <slot v-if="i18n.locale.value == 'en'">
                {{item.label}}
            </slot>
            <slot v-if="!item.is_required">&nbsp;{{$t('optional')}}</slot>
        </label>
        <!--end::Label-->
        <template v-if="item.type == 'Check'">
            <div class="row">
                <div v-for="(selection,key) in item.selection_values" class="col-md-4">
                    <label
                            class="form-check form-switch form-check-custom form-check-solid">
                        <input
                                v-model="item.values"
                                class="form-check-input"
                                :name=" item.model_key + item.key"
                                type="checkbox"
                                :rules="$helpers.getValidationRules(item)"
                                :value="selection.id"
                                :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                        />
                        <span class="form-check-label fw-bold text-gray-400"> &nbsp;
                    {{i18n.locale.value == 'ar' ? selection.value_ar : selection.value}}
                </span>
                    </label>
                </div>

                <Field v-model="item.values"
                       :label="i18n.locale.value == 'ar' ? item.label_ar : item.label"
                       :name=' item.model_key + item.key'
                       :rules="$helpers.getValidationRules(item)"
                       type="hidden"
                       class="d-none"/>
            </div>
        </template>
        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<span class="text-dark">({{item.type}})</span>-->
                <slot v-if="i18n.locale.value == 'ar'">
                    <span class="text-muted">{{item.hint_text_ar}}</span>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                    <span class="text-muted">{{item.hint_text_en}}</span>
                </slot>
            </div>
        </div>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<ErrorMessage :name="item.model_key + item.key"/>-->
                <ErrorMessage :name="item.model_key + item.key" v-slot="{ message }">
                    <template v-if="item.validation_error_msg_ar  && i18n.locale.value == 'ar'">
                        <slot>
                            {{item.validation_error_msg_ar}}
                        </slot>
                    </template>
                    <template v-if="item.validation_error_msg  && i18n.locale.value == 'en'">
                        <slot>
                            {{item.validation_error_msg}}
                        </slot>
                    </template>
                    <template
                            v-if="!(item.validation_error_msg_ar  && i18n.locale.value == 'ar')  && !(item.validation_error_msg  && i18n.locale.value == 'en')">
                        <slot>
                            {{message}}
                        </slot>
                    </template>
                </ErrorMessage>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted, watch } from "vue";
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';
import * as _ from "lodash";


  export default defineComponent({
    name: 'FormCheckboxInput',
    components: {
      Field,
      ErrorMessage,
    },
    props: ['item', 'items', 'iterator'],
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      const state = reactive({
        item: props.item,
        items: props.items,
        iterator: props.iterator,
      });

      onMounted(() => {
        if (!state.item.values) {
          triggerChange([]);
        }
      });

      watch(
        () => state.item.values,
        (values, prevCount) => {
          triggerChange(values);
        },
      );

      const triggerChange = (selection = []) => {
        selection = JSON.parse(JSON.stringify(selection))
        let item: any = state.item;
        let iterator: any = state.iterator;
        let all_sections_keys: any = getAllSections(item);
        let selected_section_values: any = getSelectValue(item, selection);
        let difference:any = all_sections_keys.filter(x => !_.map(selected_section_values,'model_key').includes(x));

        // remove item
        let removalKeys: any = difference;
        _.remove(state.items, function(currentObject: any) {
          return removalKeys.includes(currentObject.model_key);
        });

        _.forEach(selected_section_values,(section)=>{
          if (!checkIfSectionAdded(state.items,section.model_key)){
            state.items.splice(iterator + 1 , 0, cloneSection(section));
          }
        });
      };

      const cloneSection = (section) => {
        let clonedSectionItem: any = Object.assign({}, section);
        clonedSectionItem.key = `_main_${Math.random().toString(16)}`;
        clonedSectionItem.section_repeat_index = 1;

        let itemsR: any = [];
        _.forEach(clonedSectionItem.items, (oldItem) => {
          // oldItem = JSON.parse(JSON.stringify(oldItem));
          oldItem.key = `_sub_${Math.random().toString(16)}`;
          oldItem.value = null;
          oldItem.values = [];
          if(oldItem.type != "Section") itemsR.push(oldItem);
        });
        return clonedSectionItem;
      };

      const getSelectValue = (item, values) => {
        let Gitems: any = [];
        _.forEach(item.selection_values, (_item) => {
          if (values.includes(_item.id) && _item.section) {
            Gitems.push(JSON.parse(JSON.stringify(_item.section)));
          }
        });

        return Gitems;
        // return _.filter(Gitems,(i) => {
        //   return i.section;
        // });
      };
      const getAllSections = (item) => {
        let Gitems: any = [];
        _.forEach(item.selection_values, (_item) => {
          if (_item.section) {
            Gitems.push(JSON.parse(JSON.stringify(_item)));
          }
        });
        return _.map(Gitems,"section.model_key");
      };

      const checkIfSectionAdded = (items, modelKey) => {
        for (let i = 0; i < items.length; i++) {
          if (items[i].model_key == modelKey) {
            return true;
          }
        }
        return false;
      };
      return {
        ...toRefs(state),
        i18n,
        helpers,
      };
    },
  });
</script>
